class YandexMap {

    constructor(args) {
        let self = this;
        if (!args.root || !args.root.length) return;
        self._elems.$_ = args.root;
        self._state.args = args.args || {};

        self._init();

        return self;
    }

    _elems = {
        $_ : $()
    };

    _state = {
        map        : null,
        collection : null,
        args       : {}
    };

    _render = () => {
        let self = this;

        let args = {};
        if (self._elems.$_.data('location')) {
            args = Object.assign(args, {
                center : self._elems.$_.data('location').split(',')
            });
        }
        if (self._elems.$_.data('zoom')) {
            args = Object.assign(args, {
                zoom : self._elems.$_.data('zoom')
            });
        }

        args = Object.assign(args, {
            controls             : ['geolocationControl', 'zoomControl'],
            suppressMapOpenBlock : true
        });

        let done = function() {
            self._state.map = new ymaps.Map(self._elems.$_.attr('id'), args, {
                searchControlProvider: 'yandex#search',
            });

            self._state.map.behaviors.disable('scrollZoom');

            self._state.collection = new ymaps.GeoObjectCollection({}, {
                draggable: false
            });

            self._state.args.afterRender && self._state.args.afterRender({
                map : self._state.map
            });
        };

        let run = false;
        if (ymaps.Map == undefined) {
            run = setInterval(function(){
                if (ymaps.Map != undefined) {
                    clearInterval(run);
                    done();
                }
            }, 1000);
        }
        else {
            done();
        }
    };

    _init = () => {
        let self = this;

        self._render();
    };

    destroy = () => function(){
        let self = this;
        self._state.map.destroy();
    };

    setCenter = (coordinates, zoom) => {
        let self = this;
        self._state.map.setCenter(coordinates, zoom);
    };

    toGlobalPixels = (coords, zoom) => {
        if(coords !== undefined && ymaps.projection !== undefined) {
            return ymaps.projection.wgs84Mercator.toGlobalPixels(coords, zoom);
        }
        else {
            return null;
        }
    };

    fromGlobalPixels = (pixels, zoom) => {
        return ymaps.projection.wgs84Mercator.fromGlobalPixels(pixels, zoom);
    };

}

export default YandexMap;